export default "__VITE_ASSET__Bm1k6U7q__"